import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Slide,
  Grid,
  useTheme,
  makeStyles,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { validarRUT } from "validar-rut";
import { useForm } from "react-hook-form";
import MaskedInput from "react-text-mask";
import { TextField } from "./";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AddOperator(props) {
  const operatorTypes = [
    { value: "OPERADOR", label: "Operador" },
    { value: "CHILD_OPERATOR", label: "Sub operador" },
  ];
  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { register, handleSubmit, errors, watch } = useForm();
  const [rut, setRut] = useState("");
  const [lenName, setLenName] = useState(0);
  const [lenUser, setLenUser] = useState(0);
  const [operatorType, setOperatorType] = useState(operatorTypes[0].value);
  const [parentOperator, setParentOperator] = useState(null);
  const { close, addOperator, operatorsList } = props;

  const saveOperator = (dataToInsert) => {
    const operator = {
      username: dataToInsert.username,
      email: dataToInsert.email,
      password: dataToInsert.password,
      operatorType: operatorType,
      operator: {
        name: dataToInsert.name,
        rut: dataToInsert.rut,
        address: dataToInsert.address,
        contact: dataToInsert.contact,
        phone: dataToInsert.phone,
        ...(operatorType === "CHILD_OPERATOR" && parentOperator
          ? { parentOperatorId: parentOperator }
          : {}),
      },
    };
    close();
    addOperator(operator);
  };

  return (
    <Dialog
      PaperProps={{ style: { borderRadius: 45 } }}
      maxWidth="sm"
      fullScreen={fullScreen}
      open={props.open}
      TransitionComponent={Transition}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={props.close}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle className={classes.dialogTitle}>
        Agregar Operador
      </DialogTitle>
      <DialogContent>
        <form className={classes.form} onSubmit={handleSubmit(saveOperator)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl
                fullWidth
                variant="outlined"
                className={`${classes.formControl}  ${classes.shrinkLabel}`}
                style={{ position: "relative" }}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Tipo de operador
                </InputLabel>
                <Select
                  fullWidth={true}
                  labelId="demo-mutiple-name-label"
                  id="demo-mutiple-name"
                  label="Unidad de negocio"
                  value={operatorType}
                  onChange={(e) => {
                    setOperatorType(e.target.value);
                  }}
                  MenuProps={MenuProps}
                  className={classes.select}
                >
                  {operatorTypes.map((element, index) => {
                    return (
                      <MenuItem key={index} value={element.value}>
                        {element.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            {operatorType === "CHILD_OPERATOR" && (
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  className={`${classes.formControl}  ${classes.shrinkLabel}`}
                  style={{ position: "relative" }}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Operador padre
                  </InputLabel>
                  <Select
                    fullWidth={true}
                    labelId="demo-mutiple-name-label"
                    id="demo-mutiple-name"
                    label="Unidad de negocio"
                    value={parentOperator}
                    onChange={(e) => {
                      setParentOperator(e.target.value);
                    }}
                    MenuProps={MenuProps}
                    className={classes.select}
                  >
                    {operatorsList.map((element, index) => {
                      if (
                        element.user.role._id === "602d4e260ecf5949dc06334e"
                      ) {
                        return (
                          <MenuItem key={index} value={element._id}>
                            {element.name}
                          </MenuItem>
                        );
                      }
                      return null;
                    })}
                  </Select>
                  <FormHelperText
                    id="helperParentOperator"
                    error={operatorType === "CHILD_OPERATOR" && !parentOperator}
                  >
                    {operatorType === "CHILD_OPERATOR" && !parentOperator
                      ? "Seleccione un operador padre"
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="name"
                placeholder="Nombre *"
                name="name"
                autoComplete="name"
                onChange={(e) => setLenName(e.target.value.length)}
                size="small"
                inputRef={register({
                  required: "Nombre requerido",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={
                  errors.name
                    ? true
                    : lenName < 6 || lenName > 15
                    ? true
                    : false
                }
                helperText={
                  errors.name
                    ? errors.name.message
                    : lenName < 6 || lenName > 15
                    ? "Nombre de contener entre 6 y 15 caracteres"
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="rut"
                placeholder="Rut *"
                name="rut"
                autoComplete="rut"
                size="small"
                value={rut}
                onChange={(e) => setRut(e.target.value)}
                inputComponent={TextMaskCustom}
                inputRef={register({
                  required: "Rut requerido",
                  validate: (value) => validarRUT(value) || "Rut incorrecto",
                })}
                InputLabelProps={{
                  shrink: true,
                  style: { borderRadius: 25 },
                }}
                error={errors.rut ? true : false}
                helperText={errors.rut ? errors.rut.message : ""}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="email"
                placeholder="Correo electrónico *"
                name="email"
                size="small"
                autoComplete="email"
                inputRef={register({
                  required: "Correo requerido",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Formato de correo inválido",
                  },
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.email ? true : false}
                helperText={errors.email ? errors.email.message : ""}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="address"
                placeholder="Dirección *"
                name="address"
                autoComplete="address"
                size="small"
                inputRef={register({
                  required: "Dirección requerida",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.address ? true : false}
                helperText={errors.address ? errors.address.message : ""}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="contact"
                placeholder="Contacto *"
                name="contact"
                autoComplete="cotact"
                size="small"
                inputRef={register({
                  required: "Persona de contacto requerida",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.contact ? true : false}
                helperText={errors.contact ? errors.contact.message : ""}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="phone"
                placeholder="Teléfono *"
                name="phone"
                autoComplete="phone"
                size="small"
                inputRef={register({
                  required: "Teléfono requerido",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.phone ? true : false}
                helperText={errors.phone ? errors.phone.message : ""}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="username"
                placeholder="Usuario *"
                name="username"
                type="username"
                autoComplete="username"
                onChange={(e) => setLenUser(e.target.value.length)}
                size="small"
                inputRef={register({
                  required: "Usuario requerido",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={
                  errors.username
                    ? true
                    : lenUser < 6 || lenUser > 15
                    ? true
                    : false
                }
                helperText={
                  errors.username
                    ? errors.username.message
                    : lenUser < 6 || lenUser > 15
                    ? "Usuario debe contener entre 6 y 15 caracteres"
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="password"
                placeholder="Contraseña *"
                name="password"
                type="password"
                autoComplete="password"
                size="small"
                inputRef={register({
                  required: "Contraseña requerida",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.password ? true : false}
                helperText={errors.password ? errors.password.message : ""}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="passworRepeat"
                placeholder="Confirmar contraseña *"
                name="passworRepeat"
                type="password"
                autoComplete="passworRepeat"
                size="small"
                inputRef={register({
                  required: "Confirmar contraseña requerida",
                  validate: (value) =>
                    value === watch("password") ||
                    "Las contraseñas no coinciden.",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.passworRepeat ? true : false}
                helperText={
                  errors.passworRepeat ? errors.passworRepeat.message : ""
                }
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              fullWidth
              size="small"
              variant="contained"
              color="secondary"
              className={classes.submit}
              style={{ textTransform: "capitalize", borderRadius: "20px" }}
            >
              Guardar
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  const { value } = other;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={
        value.length <= 9
          ? [
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              "-",
              /[kK0-9]/,
              /[kK0-9]/,
            ]
          : [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]+/g]
      }
      placeholderChar={"\u2000"}
      placeholder="Rut *"
      style={{ color: "#192A7F" }}
      guide={false}
      showMask
    />
  );
}

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: "#FFF",
    backgroundColor: theme.palette.secondary.main,
    width: 30,
    height: 30,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  dialogTitle: {
    textAlign: "left",
    color: theme.palette.primary.main,
    "& h2": {
      fontWeight: "bold",
    },
  },
}));
